import React from "react"
import Layout from "../components/Layout/Layout"
import styles from "../style/work.module.css"
import { AnchorLink } from "gatsby-plugin-anchor-links"
import { StaticImage } from "gatsby-plugin-image"
import Scrollspy from "react-scrollspy"

export default function works() {
  const ListLink = props => (
    <li className={styles.list}>
      <AnchorLink smooth to={props.to}>
        {" "}
        {props.children}{" "}
      </AnchorLink>
    </li>
  )
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.layout}>
          <div className={styles.wrapper}>
            <section id="energyaudit">
              <h1 className={styles.subtitle}>
                {" "}
                <span className="underline">Эрчим хүчний аудит</span>
              </h1>

              <section id="section-21">
                <h3>Их наяд плаза</h3>
                <StaticImage
                  src="../images/ih nayad.png"
                  alt="plan"
                  style={{ maxWidth: "500px" }}
                />
                <br />
                Эх газар ХХК-ийн Их наяд плаза барилгад анхан шатны (ерөнхий)
                аудит хийлээ. Тус аудитаар барилгын 2020-2021 оны эрчим хүчний
                дундаж хэрэглээгээр суурь үзүүлэлтийг тодорхойлж, хөрөнгө мөнгө
                зарахгүйгээр эсвэл хамгийн бага зардлаар эрчим хүч хэмнэх
                боломжуудыг судлаж зөвлөв. Гэрээнд заасны дагуу аудитын тайланг
                2022 оны 10-р сарын 24-нд Захиалагчид хүлээлгэн өглөө.
                <br />
                Байгууллагын бизнес төлөвлөгөө, санхүүгийн чадавхи, удирдлагын
                саналыг үндэслэн Аудитын тайланд тусгасан зөвлөмжүүдээс 10 ажлыг
                сонгон авч 2022-2025 онд хэрэгжүүлэх “Эрчим хүчний үр ашгийг
                дээшлүүлэх төлөвлөгөө”-нд тусгав. Хэрэглэгч төлөвлөгөөнд
                тусгасан ажлуудыг хугацаанд нь амжилттай хэрэгжүүлбэл жилд жилд
                161.38 тонн хүлэмжийн хийн ялгарлыг бууруулах боломжтой.
              </section>
              <section id="section-22">
                <h3>Cоёолж ХХК</h3>
                <StaticImage
                  src="../images/soyolj.png"
                  alt="plan"
                  style={{ maxWidth: "500px" }}
                />
                <br />
                Cоёолж ХХК-ийн Шинэ тэрэг палаза, Цэцэг төв барилгуудад анхан
                шатны (ерөнхий) аудит хийлээ. Тус аудитаар барилгын 2020-2021
                оны эрчим хүчний дундаж хэрэглээгээр суурь үзүүлэлтийг
                тодорхойлж, хөрөнгө мөнгө зарахгүйгээр эсвэл хамгийн бага
                зардлаар эрчим хүч хэмнэх боломжуудыг судлаж зөвлөв. Гэрээнд
                заасны дагуу аудитын тайланг 2022 оны 10-р сарын 24-нд
                Захиалагчид хүлээлгэн өглөө.
                <br />
                Байгууллагын бизнес төлөвлөгөө, санхүүгийн чадавхи, удирдлагын
                саналыг үндэслэн Аудитын тайланд тусгасан зөвлөмжүүдээс 7 ажлыг
                сонгон авч 2022-2025 онд хэрэгжүүлэх “Эрчим хүчний үр ашгийг
                дээшлүүлэх төлөвлөгөө”-нд тусгав. Хэрэглэгч төлөвлөгөөнд
                тусгасан ажлуудыг хугацаанд нь амжилттай хэрэгжүүлбэл жилд жилд
                131 тонн хүлэмжийн хийн ялгарлыг бууруулах боломжтой.
              </section>
              <section id="section-0">
                <h3>Хангай дээд сургуульд хийсэн эрчим хүчний аудит</h3>
                <StaticImage
                  src="../images/plan-2.JPG"
                  alt="plan"
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  2021 оны 05-р сарын 10-наас 8-р сарын 17-ны хооронд Хангай
                  дээд сургуулийн эзэмшлийн барилгуудад эрчим хүчний анхан шатны
                  аудит хийх төслийг бие даасан аудиторын эрхийн хүрээнд
                  амжилттай хэрэгжүүллээ. Эрчим хүчний аудитын төслийг анх удаа
                  ЕСБХБ-ны тэтгэлэгт хамруулсан нь өмнөх төслүүдээс онцлог
                  байлаа. <br /> Хангай дээд сургуулийн эзэмшлийн объектуудын
                  эрчим хүчний хэрэглээнд дүн шинжилгээ хийж, хөрөнгө мөнгө
                  зарахгүйгээр эсвэл хамгийн бага зардлаар эрчим хүчний үр
                  ашгийг дээшлүүлэх замаар хүлэмжийн хийн ялгарлыг бууруулах
                  боломжийг тодорхойллоо. Аудитын тайланд халаалтын болон
                  цахилгааны зардлыг бууруулах, дотор агаарын чанарыг
                  сайжруулах, менежментийг сайжруулах гэсэн дөрвөн чиглэлээр 22
                  зөвлөмж өгснөөс 10 ажлыг сонгож 2024 он хүртэл хэрэгжүүлэх
                  “Эрчим хүчний үр ашгийг дээшлүүлэх төлөвлөгөө”-нд тусгаж
                  баталгаажууллаа.
                </p>
                <br />
                {/* <b> */}
                Эдгээр ажлуудыг хэрэгжүүлснээр хэрэглэгч жилд 352.9 тонн
                хүлэмжийн хийн ялгарлыг бууруулах боломжтой.
                {/* </b> */}
              </section>
              <section id="section-a">
                <h3>МТҮП-ийн эрчим хүчний аудит</h3>
                <StaticImage
                  src="../images/гадна тал.JPG"
                  alt="plan"
                  style={{ maxWidth: "500px" }}
                />
                <div>
                  МТҮП ТӨААТҮГ-ын эзэмшлийн барилгын Өргөө-2 кинотеатраас бусад
                  хэсгийн цахилгаан хангамжийн системд хэсэгчилсэн аудит хийлээ.
                  Тус аудитаар Өргөө-2 кинотеатраас бусад хэсгийн цахилгаан
                  хангамжийн системийн эрчим хүчний үр ашигтай байдлыг
                  дээшлүүлэх шийдлийг тодорхойлж, найдвартай ажиллагааг
                  сайжруулах арга аргачлалыг зөвлөсөн. Мөн байгууллагын бизнес
                  төлөвлөгөө, удирдлагын саналыг үндэслэн техникийн шинэчлэл
                  хийх боломж, СЭХ-ний нөөц ашиглах боломжуудыг судлаж зөвлөв.
                  Гэрээнд заасны дагуу аудитыг 06 сарын 26-аас 9-р сарын 20-ны
                  хооронд гүйцэтгэж тайланг захиалагчид хүлээлгэн өглөө.
                </div>
                <br />
                <div>
                  Байгууллагын бизнес төлөвлөгөө, санхүүгийн чадавхи, удирдлагын
                  саналыг үндэслэн Аудитын тайланд тусгасан зөвлөмжүүдээс 6
                  ажлыг сонгон авч 2021-2024 онд хэрэгжүүлэх “Эрчим хүчний үр
                  ашгийг дээшлүүлэх төлөвлөгөө”-нд тусгав. Эдгээр ажлуудыг
                  хэрэгжүүлснээр хэрэглэгч жилд 57.9 тонн хүлэмжийн хийн
                  ялгарлыг бууруулах боломжтой.
                </div>
              </section>
              <section id="section-1">
                <h3>Гутал ХК-д хийсэн эрчим хүчний аудит</h3>
                <StaticImage
                  src="http://gutalco.mn/files/object.jpg"
                  alt="gutal"
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  2020 оны 11-р сараас 2021 оны 2-р сарын хооронд бие даасан
                  даасан аудиторын эрхийн хүрээнд Гутал ХК-ийн эзэмшлийн
                  объектуудад эрчим хүчний аудит хийлээ. Энэхүү аудитаар Гутал
                  ХК-ийн эзэмшлийн үйлчилгээний зориулалттай 68 объектын эрчим
                  хүчний өнөөгийн байдалд үзлэг, хэмжилт, дүн шинжилгээ хийж,
                  эрчим хүчний үр ашгийг дээшлүүлэх арга аргачлалыг тодорхойлж,
                  дүгнэлт зөвлөмж бүхий аудитын тайланг хүлээлгэн өглөө. Гутал
                  ХК-ийн удирдлага, эрчим хүчний менежертэй хамтран аудитын
                  зөвлөмжийг хэрэгжүүлэх төлөвлөгөө боловсруулж ЭХЗХ-нд
                  хүргүүллээ. Төлөвлөгөөнд хамгийн бага зардлаар хэрэгжүүлж
                  болох 16 төрлийн ажлуудыг тусгасан. Дээрх ажлуудыг
                  хэрэгжүүлснээр 1,3 тонн хүлэмжийн хийн ялгарлыг бууруулах
                  боломжтой.
                </p>
              </section>
              <section id="section-2">
                <h3>Эрдэнэт баяжуулах үйлдвэрт хийсэн эрчим хүчний аудит</h3>
                <StaticImage
                  src="../images/Эрдэнэт.jpg"
                  alt="erdenet"
                  className={styles.erdenet_image}
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  2019 оны 10-р сараас 2020 оны 8-р сарын хооронд Киловатт цаг
                  ХХК-тай хамтран Эрдэнэт үйлдвэр ТӨҮГ-ын Баяжуулах үйлдвэрт
                  Киловатт цаг ХХК-тай хамтран эрчим хүчний дэлгэрэнгүй аудит
                  хийлээ. Баяжуулах үйлдвэрийн эзэмшлийн 94000 м² талбай бүхий
                  20 барилга байгууламж, 20 галарей, 1 туннелийн агаар сэлгэх
                  төхөөрөмж, дулааны эрчим хүчний хэрэглээнд үзлэг, хэмжилт, дүн
                  шинжилгээ хийж, дулаан агаар сэлгэлтийн системийн үр ашиг
                  багатай, ашиглалтын хугацаа дууссан тоног төхөөрөмжүүдийг
                  солих сайжруулах арга аргачлалыг тодорхойлсон зөвлөмж, хөрөнгө
                  оруулалтын тооцоо бүхий аудитын тайланг хүлээлгэн өгсөн.
                  Аудитын тайланд дулаан алдагдлыг бууруулах 7 шийдэл,
                  агааржуулалтын системийг сайжруулах 19 шийдэл, тоосжилтыг
                  бууруулах 9 шийдэл санал болгосон. Баяжуулах үйлдвэрийн
                  удирдлага болон эрчим хүчний менежертэй хамтарч эрчим хүчний
                  үр ашгийг дээшлүүлэх төлөвлөгөө боловсруулж, ЭХЗХ-нд
                  хүргүүлсэн. Төлөвлөгөөнд 2021-2023 онд хэрэгжүүлэх 56 төрлийн
                  ажлыг тусгасан.
                </p>
              </section>

              <section id="section-3">
                <h3>TTGVCO Зүүн цанхийн уурхайд хийсэн эрчим хүчний аудит</h3>
                <StaticImage
                  src="../images/TTGVCO.jpg"
                  alt="3"
                  style={{ maxWidth: "500px" }}
                />
              </section>
              <section id="section-4">
                <h3>
                  Мөнхийн баян гал цементийн үйлдвэрт хийсэн эрчим хүчний аудит
                </h3>
                <StaticImage
                  src="../images/цементийн үйлдвэр.jpg"
                  alt="4"
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  Киловатт цаг ХХК-ийн аудитын баг үүрэг хүлээсэн хэрэглэгч
                  болох Мөнхийн баян гал ХХК-ийн Төв аймгийн Сэргэлэн нумын
                  нутагт байрлах цементийн үйлдвэрт 2019 оны 10-р сарын 5-ны
                  өдрөөс эхлэн 1 сарын хугацаанд эрчим хүчний иж бүрэн аудитын
                  гэрээ байгуулж ажиллалаа. Аудитын гол зорилго нь Монгол улсын
                  Эрчим хүчний тухай хууль, Эрчим хүчний хэмнэлтийн хөтөлбөрийг
                  хэрэгжүүлэх ажлын хүрээнд тус үйлдвэрийн эрчим хүчний хэрэглээ
                  болон үзүүлэлтүүдэд дүн шинжилгээ хийж, нэгж бүтээгдэхдүүнд
                  ногдох эрчим хүчний хэрэглээг бууруулах, хүрээлэн буй орчинд
                  үзүүлэх сөрөг нөлөөллийг бууруулах боломжийг судлан зөвлөмж
                  өгөх явдал юм. Эрчим хүчний аудитын хамрах хүрээнд тус
                  үйлдвэрийн цогцолборын суурьшлын бүс, үйлдвэрийн бүс,
                  үйлдвэрийн хэсгийн туслах байгууламж бүхий хэсгүүдэд цахилгаан
                  хангамж, дулаан хангамж, халаалт агаар сэлгэлтийн систем болон
                  барилгуудад дулаан алдагдалдлыг тодорхойлох ажлуудыг
                  багтаасан. ХХЯ-ыг 1,5 сая тонноор бууруулах урьдчилсан
                  тооцоолол гарсан.
                </p>
              </section>
              <section id="section-5">
                <h3>JNOD цахилгаан халаагуурт хийсэн эрчим хүчний аудит</h3>
                <StaticImage
                  src="../images/JUNIOD халаагуур.JPG"
                  alt="juniod"
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  2019 онд JNOD агшин зуур цахилгаан халаагчид эрчим хүчний
                  аудит хийж, ХААН банкны ногоон зээлд хамруулах бүтээгдэхүүний
                  жагсаалтад бүртгүүлэв. JNOD агшин зуур цахилгаан халаагчийн
                  өндөр үр ашиг бүхий патентлагдсан технологид сайжруулсан
                  шахмал хөнгөн цагаан, зэвэрдэггүй ган, никель-хром зэрэг
                  материалыг ашигласнаар эрчим хүчний үр ашгийг нэмэгдүүлжээ.
                  Усны болон цахилгаан эрчим хүчний алагдал маш бага.
                  Зэвэрдэггүй гангаар хийсэн усны урт суваг нь температурын
                  тогтвортой байдлыг хангана. Халаалтын хоолойг хавтгай байдлаар
                  тарааж гадаргуугийн дулааны ачааллыг бууруулснаар халаалтын
                  элементийн ашиглалтын хугацааг нэмэгдүүлсэн байна. Зураг-1-д
                  халаагч элементийг бүтцийг харуулав.
                </p>
              </section>
              <section id="section-6">
                <h3>
                  Орчлон ахлан сургуулийн зураг төслийн эрчим хүчний аудит{" "}
                </h3>
                <StaticImage
                  src="https://www.teacherhorizons.com/static/mediav2/schools/4988/images/507647_main.jpg"
                  alt="orchlon"
                  style={{ maxWidth: "500px" }}
                />
              </section>
              <section id="section-7">
                <h3>ЭХЗХ-ны барилгын аудит (дадлага ажил) </h3>
                <p>
                  2017 онд Эрчим хүч хэмнэлтийн тухай хуулийн хүрээнд барилгын
                  зураг төсөл, ашиглалтанд хүлээж авсан акт, барилгын ашиглалтын
                  байдал, эрчим хүч нийлүүлэгч байгууллагуудын тавьж байсан
                  нэхэмжлэхүүдийн хэмжилт, үнэ бодолтын бодит байдал, чанар,
                  давтамжийг задлан шинжлэх, хямд зардлаар эрчим хүчний хэмнэлт
                  гаргах боломжийн талаар санал, зөвлөмж боловсруулах зорилготой
                  ажиллаа.
                </p>
                <StaticImage
                  src="../images/ЭХЗХ-ны барилга.JPG"
                  alt="barilga"
                  style={{ maxWidth: "500px" }}
                />
              </section>
              <section id="section-8">
                <h3>Эрчим хүчний жишиг аудит</h3>
                <ul>
                  <li>ХААИС</li>
                  <li>Чингис зочид буудал</li>
                  <li>УБДС ТӨХК</li>
                  <li>УБЦТС ТӨХК</li>
                  <li>ДЦС-3 ТӨХК</li>
                  <li>Налайх ДС ТӨХК</li>
                  <li>Витафит үйлдвэр </li>
                </ul>
              </section>
            </section>
            <section id="udirdlagiin_togtoltsoo">
              <h1 className={styles.subtitle}>
                {" "}
                <span className="underline">
                  Эрчим хүчний удирдлагын тогтолцооны чиглэлээр хийсэн ажлууд
                </span>
              </h1>
              <section id="section-9">
                <h3>ISO 50001:2018 стандартын орчуулга</h3>
                <StaticImage
                  src="../images/ISO 50001.JPG"
                  alt="iso"
                  style={{ maxWidth: "500px" }}
                />
                <p>
                  <ul>
                    <li>
                      <b>Ажлын нэр:</b> “Эрчим хүчний удирдлагын тогтолцооны MNS
                      ISO-50001:2018 стандарт”-ын орчуулга
                    </li>
                    <li>
                      <b>Захиалагч:</b> Обсерв ХХК
                    </li>
                    <li>
                      <b>Оролцоо:</b> Туслан гүйцэтгэгч
                    </li>
                    <li>
                      <b>Хэрэгжүүлсэн огноо:</b> 2019 оны 7-р сар
                    </li>
                    <li>
                      <b>Гүйцэтгэсэн ажил:</b> Хавсралт-А “Стандартыг
                      хэрэгжүүлэх аргачлал”
                    </li>
                  </ul>
                </p>
              </section>
              <section id="section-10">
                <h3>
                  ТЕСО ХХК Милко үйлдвэрийн дотоод аудитын хяналтын хуудас
                </h3>
                <StaticImage
                  src="../images/ТЕСО.JPG"
                  alt="teso"
                  style={{ maxWidth: "500px" }}
                />
                <ul>
                  <li>
                    <b>Ажлын нэр:</b> “TЕСО МИЛКО үйлдвэрт ISO-50001:2018
                    стандарт хэрэгжүүлэх төсөл”
                  </li>
                  <li>
                    <b>Захиалагч:</b> Обсерв ХХК
                  </li>
                  <li>
                    <b>Оролцоо:</b> Туслан гүйцэтгэгч
                  </li>
                  <li>
                    <b>Хэрэгжүүлсэн огноо:</b> 2019 оны 8-р сар
                  </li>
                  <li>
                    <b>Гүйцэтгэсэн ажил:</b> “TЕСО МИЛКО үйлдвэрт ISO-50001:2018
                    стандарт хэрэгжүүлэх төсөл”-ийн хүрээнд дотоод аудиторуудад
                    зориулж “Компрессорын ажиллагааны хяналтын хуудас”
                    боловсруулсан
                  </li>
                </ul>
              </section>
              <section id="section-11">
                <h3>Эрчим хүчний үр ашиг семинар</h3>
                <StaticImage
                  src="../images/Семинар.JPG"
                  alt="seminar"
                  style={{ maxWidth: "500px" }}
                />
                <ul>
                  <li>
                    <b>Ажлын нэр:</b> “ЭРЧИМ ХҮЧНИЙ ХЭМНЭЛТ БА ҮР АШИГ” семинар
                  </li>
                  <li>
                    <b>Захиалагч:</b> Обсерв ХХК
                  </li>
                  <li>
                    <b>Оролцоо:</b> Семинар зохион байгуулах ажлын хэсгийн
                    гишүүн, Модератор, Илтгэгч
                  </li>
                  <li>
                    <b>Хэрэгжүүлсэн огноо:</b> 2019 оны 10-р сарын 23-ны өдөр
                  </li>
                  <li>
                    <b>Гүйцэтгэсэн ажил:</b>
                    <ul className={styles.sublist}>
                      <li>
                        Семинарыг угтаж ISO-50001:2018 стандартыг олон нийтэд
                        таниулан суртачлах мэдлэг хуваалцах уулзалтыг 2019 оны
                        8-9-р саруудад 3 удаа зохион байгууллаа.
                      </li>
                      <li>
                        Семинарт оролцогчид, илтгэгч нар, ивээн тэтгэгч, шийдвэр
                        гаргагч байгууллагуудыг Обсерв ХХК-тай холбоо тогтоож;
                      </li>
                      <li>“ISO-50000 бүлгийн стандарт” илтгэл тавьж;</li>
                      <li>
                        “Үүрэг хүлээсэн хэрэглэгчдэд Эрчим хүчний удирдлагын
                        тогтолцооны стандарт нэвтрүүлэхэд тулгамдаж буй асуудал,
                        шийдвэрлэх арга зам” сэдвээр хэлэлцүүлэгийг удирдав.
                      </li>
                    </ul>
                  </li>
                </ul>
              </section>
              <section id="section-12">
                <h3 id="section-11">
                  ISO 50001:2018 стандартын мэдлэг хуваалцах уулзалтууд{" "}
                </h3>
                <ul>
                  <li>
                    <b>Ажлын нэр:</b> ISO-50001:2018 стандартын мэдлэг хуваалцах
                    уулзалтууд
                  </li>
                  <li>
                    <b>Захиалагч:</b> Обсерв ХХК
                  </li>
                  <li>
                    <b>Оролцоо:</b> Сургагч багш
                  </li>
                  <li>
                    <b>Хэрэгжүүлсэн огноо:</b> 2019 оны 8-9-р саруудад
                  </li>
                  <li>
                    <b>Гүйцэтгэсэн ажил:</b>ISO-50001:2018 стандартыг олон
                    нийтэд таниулан суртачлах, татан оролцуулах зорилгоор Эрчим
                    хүчний удирдлагын тогтолцооны ISO-50001:2018 стандартын
                    бүтэц, агуулга, зорилго, түүнийг хэрэгжүүлэх шаардлага, ач
                    холбогдол, эрчим хүчний аудитаас ялгагдах ялгаа зэргийг
                    тайлбарлав.
                  </li>
                </ul>
              </section>
            </section>
            <section id="research_works">
              <h1 className={styles.subtitle}>
                {" "}
                <span className="underline">
                  Эрдэм шинжилгээ судалгааны ажлууд
                </span>
              </h1>
              <section id="section-13">
                <h3>НҮБ-ын “Барилгын НАМА” төсөл </h3>
                <StaticImage
                  src="../images/NAMA.JPG"
                  alt="nama"
                  style={{ maxWidth: "500px" }}
                />
              </section>
              <section id="section-14">
                <h3>
                  Монгол улсын “Түлш эрчим хүчний нэгдсэн баланс” судалгааны
                  ажил
                </h3>
                <StaticImage
                  src="../images/ТЭХ-ний нэгдсэн баланс.JPG"
                  alt="ТЭХ-ний нэгдсэн баланс"
                  style={{ maxWidth: "500px" }}
                />
              </section>
              {/* <section id="section-15"></section>
                                <h3>“ЭХХ-ийн индикатор”  судалгааны ажил</h3>
                                <section id="section-16"></section>
                                <h3>Хүчдлийн шинэ түвшин”  судалгааны ажил</h3>
                                <section id="section-17"></section>
                                <h3>“ЗХА-ийн нэгдсэн сүлжээ” судалгааны ажил</h3> */}
            </section>
          </div>
          <div className={styles.submenu}>
            <ul className={styles.submenu_list}>
              <Scrollspy
                items={["energyaudit"]}
                currentClassName={styles.main_current}
                offset={-100}
              >
                <li>
                  <li className={styles.main_title}>
                    <AnchorLink smooth to="/works/#energyaudit">
                      {" "}
                      Эрчим хүчний аудит{" "}
                    </AnchorLink>
                  </li>
                </li>
              </Scrollspy>
              <ul>
                <Scrollspy
                  items={[
                    "section-21",
                    "section-22",
                    "section-0",
                    "section-a",
                    "section-1",
                    "section-2",
                    "section-3",
                    "section-4",
                    "section-5",
                    "section-6",
                    "section-7",
                    "section-8",
                  ]}
                  currentClassName={styles.current}
                  offset={-200}
                >
                  <li>
                    <ListLink to="/works/#section-21">Их наяд плаза</ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-22">Cоёолж ХХК</ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-0">
                      Хангай Дээд Сургуульд хийсэн эрчим хүчний аудит
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-a">
                      МТҮП-ийн эрчим хүчний аудит
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-1">Гутал ХК</ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-2">
                      Эрдэнэт Баяжуулах үйлдвэр{" "}
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-3">
                      TTGVCO Зүүн цанхийн уурхай
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-4">
                      Мөнхийн баян гал Цементийн үйлдвэр
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-5">
                      JNOD цахилгаан халаагуур
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-6">
                      Орчлон ахлах сургууль
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-7">ЭХЗХ-ны барилга</ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-8">
                      Эрчим хүчний жишиг аудит
                    </ListLink>
                  </li>
                </Scrollspy>
              </ul>
              <Scrollspy
                items={["udirdlagiin_togtoltsoo"]}
                currentClassName={styles.current}
                offset={-100}
              >
                <li>
                  <li className={styles.main_title}>
                    <AnchorLink smooth to="/works/#udirdlagiin_togtoltsoo">
                      {" "}
                      Эрчим хүчний удирдлагын тогтолцооны стандарт{" "}
                    </AnchorLink>
                  </li>
                </li>
              </Scrollspy>
              <ul>
                <Scrollspy
                  items={[
                    "section-9",
                    "section-10",
                    "section-11",
                    "section-12",
                  ]}
                  currentClassName={styles.current}
                  offset={-200}
                >
                  <li>
                    <ListLink to="/works/#section-9">
                      ISO 50001:2018 стандартын орчуулга
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-10">
                      ТЕСО ХХК. Милко үйлдвэр
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-11">
                      Эрчим хүчний үр ашиг семинар
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-12">
                      ISO 50001:2018 мэдлэг хуваалцах уулзалтууд
                    </ListLink>
                  </li>
                </Scrollspy>
              </ul>
              <Scrollspy
                items={["research_works"]}
                currentClassName={styles.current}
                offset={-100}
              >
                <li>
                  <li className={styles.main_title}>
                    <AnchorLink smooth to="/works/#research_works">
                      {" "}
                      Эрдэм шинжилгээ судалгааны ажлууд{" "}
                    </AnchorLink>
                  </li>
                </li>
              </Scrollspy>
              <ul>
                <Scrollspy
                  items={[
                    "section-13",
                    "section-14",
                    "section-15",
                    "section-16",
                    "section-17",
                  ]}
                  currentClassName={styles.current}
                >
                  <li>
                    <ListLink to="/works/#section-13">
                      НҮБ-ын “Барилгын НАМА” төсөл
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-14">
                      Монгол улсын “Түлш эрчим хүчний нэгдсэн баланс” судалгааны
                      ажил
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-15">
                      “ЭХХ-ийн индикатор” судалгааны ажил
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-16">
                      Хүчдлийн шинэ түвшин” судалгааны ажил
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-17">
                      “ЗХА-ийн нэгдсэн сүлжээ” судалгааны ажил
                    </ListLink>
                  </li>
                </Scrollspy>
              </ul>
              <Scrollspy
                items={["others"]}
                currentClassName={styles.current}
                offset={-100}
              >
                <li>
                  <li className={styles.main_title}>
                    <AnchorLink smooth to="/works/#others">
                      {" "}
                      Бусад төслүүд{" "}
                    </AnchorLink>
                  </li>
                </li>
              </Scrollspy>
              <ul>
                <Scrollspy
                  items={["section-18", "section-19"]}
                  currentClassName={styles.current}
                  offset={-200}
                >
                  <li>
                    <ListLink to="/works/#section-18">
                      Ухаа худаг дэд станцийн төсөл
                    </ListLink>
                  </li>
                  <li>
                    <ListLink to="/works/#section-19">
                      110 кВ-ын налайх ЦДАШ-ын шилэн кабелийн төсөл
                    </ListLink>
                  </li>
                </Scrollspy>
              </ul>
            </ul>
          </div>
        </div>
      </div>
      Ө
    </Layout>
  )
}
